import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { ISPJBPDataResponse } from '../../../services/models/ISPJBPDataResponse'

export const getShortTermData = async <T>(
  uid: string,
  forceUpdate: boolean,
  cancelObject?: HttpCancel
): Promise<ISPJBPDataResponse<T>> => {
  let response

  const url = proxy('/webservice/197/sp/v4/spJBPELTKeyInitiatives/call')
  const payload = { 'p.UID': uid, 'p.Mode': forceUpdate ? 1 : 0 }

  try {
    response = await Rest.post({ url, payload, cancelObject })
  } catch (e: any) {
    const errorMessage = `Failed to request ELT Short Term data by UID '${uid}'`
    Logger.error(`${errorMessage}: ${e.message}`)

    response = {
      Total: -1,
      Data: [],
      Errors: errorMessage,
    }
  }

  return response
}
